<template>
    <div v-if="hasErrors">
        <div class="font-medium text-red-600">
            <slot>Whoops! Something went wrong.</slot>
        </div>

        <ul class="mt-3 list-disc list-inside text-sm text-red-600">
            <li v-for="(error, key) in errors" :key="key">{{ error }}</li>
        </ul>
    </div>
</template>

<script>
    import {computed} from 'vue';

    export default {
        name: 'ValidationErrors',
        props: ['errors'],

        setup(props) {
            const errors = computed(() => {
                return props.errors;
            });

            const hasErrors = computed(() => {
                return Object.keys(errors.value).length > 0;
            });

            return {
                errors,
                hasErrors,
            }
        },
    }
</script>

<style scoped>

</style>
